var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notranslate",attrs:{"id":"app","translate":"no"}},[_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }